import { z } from 'zod';

import { Button } from '@apps/web/components/ui/button';
import { type MetricsInsightsWindow } from '@apps/web/swr_data_fetching/organization_metrics_queries';

export const INSIGHTS_WINDOW_SCHEMA = z.enum(['24h', '7d', '30d', '90d']);

export const DEFAULT_INSIGHTS_WINDOW: MetricsInsightsWindow = '30d';

export const INSIGHTS_WINDOW_OPTIONS: ReadonlyArray<{
    readonly value: MetricsInsightsWindow;
    readonly label: string;
}> = [
    { value: '24h', label: '24h' },
    { value: '7d', label: '7d' },
    { value: '30d', label: '30d' },
    { value: '90d', label: '90d' },
];

type InsightsWindowPickerProps = {
    readonly value: MetricsInsightsWindow;
    readonly onChange: (value: MetricsInsightsWindow) => void;
};

export function InsightsWindowPicker({
    value,
    onChange,
}: InsightsWindowPickerProps) {
    return (
        <div className="flex flex-wrap items-center gap-2">
            {INSIGHTS_WINDOW_OPTIONS.map((option) => (
                <Button
                    key={option.value}
                    variant={value === option.value ? 'default' : 'outline'}
                    size="sm"
                    aria-pressed={value === option.value}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </Button>
            ))}
        </div>
    );
}
